import { IAnimation, ISkeletonData, Spine } from "@modules/pixi-spine";
import { ISystemContext, SystemContext } from "../../Context/SystemContext";
import { CreateSpineResources, Rect, Scale, Size } from "../../MyHelpers";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager, LoadingStage } from "../../ResourceManager/ResourceManager";
import * as PIXI from "pixi.js";
import { SlotGameBet } from "../../api";
import { FillingPotGeneric, PlaceHolderMutiPotConfig } from "../FillingPot/FillingPotGeneric";
import { FillingPotParams } from "../FillingPot/FillinPotParams";
import { Track } from "../../AudioManager";
import { Settings } from "../../Settings";
import { ClientState } from "../../ClientState";
import { ResponsiveSizeContainer, FixedSizeFitContainer } from "../../../singlegame/ResponsiveHelpers";
import { GetOrientation, Orientation } from "../../FitScreen";
import { PotCollectPosition } from "../FillingPot/CollectSRAPathFillingPot";
interface SizeByOrientation {
    portrait: Size,
    landscape: Size
}
export class SingleFillingPotFeature extends FillingPotGeneric {


    public constructor(parameters: FillingPotParams) {
        super(parameters);
    }

    // public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
    //     await super.PrepareResources(loadingStage, resourceManager);
    // }

    protected override async PrepareResourcesGamesPreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {

        resourceManager.AddGlobal(new JSONResource(`${this.params.gameResourcesBasePath}FillingPotFeature/1Screens/SinglePuppet/FillingPotPuppet1S.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.params.gameName}FillingPotPoppetJson`), true));
        resourceManager.AddGlobal(new AtlasResource(`${this.params.gameResourcesBasePath}FillingPotFeature/1Screens/SinglePuppet/FillingPotPuppet1S.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.params.gameName}FillingPotPoppetAtlas`), true));
        resourceManager.AddGlobal(new JSONResource(`${this.params.gameResourcesBasePath}FillingPotFeature/1Screens/SinglePuppet/FillingPotPuppet1S-properties.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.params.gameName}FillingPotPoppetProperties`), true));

    }


    protected override async PrepareResourcesGames(resourceManager: IWriteOnlyResourceManager): Promise<void> {


        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/collectHitSound` + Settings.audioFormat, this.resid.ScopedResourceName("collectHitSound")));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/collectHitStartSound` + Settings.audioFormat, this.resid.ScopedResourceName("collectHitStartSound")));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/collectHitBonus` + Settings.audioFormat, this.resid.ScopedResourceName("collectHitBonus")));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/spineAnticipation` + Settings.audioFormat, this.resid.ScopedResourceName("spineAnticipation")));

        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/bnstart` + Settings.audioFormat, this.resid.ScopedResourceName("BN_START"), false));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/LevelAnimation_Full_LevelStart` + Settings.audioFormat, this.resid.ScopedResourceName("LevelAnimation_Full_LevelStart"), false));

        // // add sounds from random animations, this sounds are not required
        // let randomAnimations = this.jsonSpine.animations
        //     .filter(anim => anim.name.startsWith("RA_"))
        //     .map(anim => anim.name)

        // let wrongAudiosDefind = this.raAudios.filter(audio => !randomAnimations.includes(audio));
        // if (wrongAudiosDefind.length > 0) {
        //     throw new Error(`Audios not defined in spine animations: ${wrongAudiosDefind.join(", ")}`);
        // }

        // let animationsWithAudio = randomAnimations.filter(anim => this.raAudios.includes(anim));

        // for (let ra of animationsWithAudio) {
        //     this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/${ra}` + Settings.audioFormat, this.resid.ScopedResourceName(ra),false));
        // }

        // randomAnimations = null;


        //PrepareAudioPerLevel

        this.levelAudios.forEach(audio => {
            this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/${audio}` + Settings.audioFormat, this.resid.ScopedResourceName(audio), false));
        })

        // this.randomAnimationFeature.PrepareResources(resourceManager, this.jsonSpine);
    }


    // protected override async PrepareResourcesGames(resourceManager: IWriteOnlyResourceManager): Promise<void> {

    //     await super.PrepareResourcesGames(resourceManager);

    // }

    // protected override async ResourcesLoadedGames(resourceManager: IReadOnlyResourceManager): Promise<void> {
    //     await super.ResourcesLoadedGames(resourceManager);
    // }
    public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager) {

        if (loadingStage == LoadingStage.GamesConfig || loadingStage == LoadingStage.GamesPreload) {
            await this.ResourcesLoadedGamesPreload(resourceManager);
        }
        else if (loadingStage == LoadingStage.Games) {
            await this.ResourcesLoadedGames(resourceManager);
        }
    }

    private puppetSize: SizeByOrientation;
    protected override async ResourcesLoadedGamesPreload(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.jsonResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.params.gameName}FillingPotPoppetJson`));
        let resource = await PIXI.Assets.load(this.jsonResource.path).finally(() => {
            PIXI.Assets.cache.remove(this.jsonResource.path);
        });
        this.jsonSpine = resource.spineData;

        this.familyName = this.jsonSpine.bones.find(bone => bone.name.startsWith("Family-")).name;

        let propertiesResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.params.gameName}FillingPotPoppetProperties`));
        this.placeHolderMutiPotConfig = propertiesResource.json?.["placeHolderMutiPotConfig"] ?? null;
        const internalPuppetSize = (propertiesResource.json?.["puppetSize"] as SizeByOrientation) ?? null;
        if (internalPuppetSize) {

            this.puppetSize = {
                portrait: new Size(internalPuppetSize.portrait.Width, internalPuppetSize.portrait.Height),
                landscape: new Size(internalPuppetSize.landscape.Width, internalPuppetSize.landscape.Height)
            }
        }

        console.log(`${this.gameName}-puppetSize:`, this.puppetSize)

        // //this.raAudios = propertiesResource.json?.["ra_audios"] ?? [];
        this.levelAudios = propertiesResource.json?.["level_audios"] ?? [];
        //console.log(`${this.gameName}-Audio-PerLevelJsonFile:`,this.levelAudios)
        console.log(`${this.gameName}-placeHolderMutiPotConfig:`, this.placeHolderMutiPotConfig)

        this.potCollectPosition = propertiesResource.json?.["potCollectPosition"] ?? [];

        console.log("PositionCollect:", this.potCollectPosition);

        this.randomAnimationFeature.ResourcesLoadedGamesPreload(resourceManager)
    }

    protected override async CreateFillinPot(skeletonData: ISkeletonData, clientState: ClientState) {
        this.CreateResponsiveElements();
        //create spine Hit
        this.spineHit = CreateSpineResources(skeletonData, false, null, PIXI.MIPMAP_MODES.ON);

        //if(Settings.Enable2plus1 == true ) this.spineHit.position.y = Scale.Y(1080);    
        this.skinsArray = this.spineHit.spineData.skins.flatMap((value, index) => value.name);
        //console.log("Skins:",this.skinsArray);
        //console.log("Skin-Selected:",this.skinAttachment);
        if (this.skinsArray.length > 1) this.spineHit.skeleton.setSkinByName(this.skinsArray[this.skinAttachment]);
        //this.spineHit.renderable = false;
        //this.spineHit.autoUpdate = true;
        this.spineHit.accessibleChildren = true;
        this.spineHit.accessible = true;
        this.spineHit.sortableChildren = true;
        //this.spineHit.zIndex = 1;
        // this.app.stage.addChild(this.spineHit);
        // this.fixedSizeFitContainer.addChild(this.spineHit);
        globalThis.gameViewAppPixiResponsive.GetReelsGameResponsiveContainer().addChild(this.spineHit);
        this.spineHit.name = "SpineHitPopet-Anim";

        let familyBone = this.spineHit.skeleton.bones.find(b => b.data.name.includes('Family-'));
        let scaleX = Scale.X(1);
        let scaleY = Scale.Y(1);

        //let controlScale = this.spineHit.skeleton.bones.find(b => b.data.name.includes('controlScale'));        

        if (familyBone) {
            //this.spineHit.skeleton.setSlotsToSetupPose();
            this.spineHit.state.update(0);
            familyBone.data.scaleX = scaleX;
            familyBone.data.scaleY = scaleY;
            if (Settings.Enable2plus1 == true && familyBone.data.y == 0) familyBone.data.y += (Settings.ScreenHeight * -1);
            this.spineHit.state.apply(this.spineHit.skeleton);
            this.spineHit.state.update(0);

            this.spineHit.skeleton.setBonesToSetupPose();
            this.spineHit.skeleton.setToSetupPose();
            //rootBone = null;

        }

        //createContainer for Reels
        //this is for all family
        // let boneRootFixPosition = this.spineHit.skeleton.findBone("reelsContainer");
        // if (boneRootFixPosition != null) {
        //     let xPosition = boneRootFixPosition.data.x;
        //     let yPosition = boneRootFixPosition.data.y;
        //     //console.log("Position-particlesHit:", boneRootFixPosition);
        //     if (boneRootFixPosition.data.x < 0) xPosition = boneRootFixPosition.data.x * -1;
        //     if (boneRootFixPosition.data.y < 0) yPosition = boneRootFixPosition.data.y * -1;
        //     this.positionSpinnableReelsSpinePivotContainer = new Size(xPosition, yPosition);
        //     xPosition = null;
        //     yPosition = null;

        //     //create container 
        //     this.containerSpinnableReelsSpine = new PIXI.Container();
        //     this.containerSpinnableReelsSpine.name = "containerParticlesHit";
        //     //this.containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
        //     this.containerSpinnableReelsSpine.scale.set(1, -1);
        //     //this.containerSpinnableReelsSpine.position.y = (Settings.ScreenHeight * (this.ScreenNumberConfiguration - 1)) * -1;


        //     //add container to particlesHit
        //     let containerchildrensSpine = this.spineHit.children as PIXI.Container[];
        //     containerchildrensSpine.forEach((container) => {
        //         if (container.name == "reelsContainer") {
        //             container.addChild(this.containerSpinnableReelsSpine);
        //             this.containerSpinnableReelsSpine.updateTransform();
        //         }
        //     });
        //     containerchildrensSpine = null;
        //     boneRootFixPosition = null;
        // }
        this.familyFillingPotFeature.CreateAnimFamilyFeature(this.spineHit, this.app, this.placeHolderMutiPotConfig);
        scaleX = null;
        scaleY = null;
        this.OnResize();
        // await this.randomAnimationFeature.StartAnimRandom(this.spineHit , clientState);
    };

    private fixedSizeFitContainer: FixedSizeFitContainer;

    public GetSRAPathView() {
        return this.familyFillingPotFeature.ViewPixiAPP();
    }

    private CreateResponsiveElements() {
        // this.responsiveSizeContainer = new ResponsiveSizeContainer(0, 0, 1, 0.13, NaN, { color: 0x550000, secondaryColor: 0x005500, name: 'puppet-responsive-container' });
        // globalThis.gameViewAppPixiResponsive.GetResponsiveView().addChild(this.responsiveSizeContainer);
        // this.fixedSizeFitContainer = new FixedSizeFitContainer(1920, 1080, { color: 0x550000, secondaryColor: 0x005500, name: 'puppet-fixed-container' });
        // this.responsiveSizeContainer.addChild(this.fixedSizeFitContainer);

    }

    private UpdatePixiAppDistribution() {

        if (!this.created) {
            return;
        }

        this.SetToDefault();
        const baseGameContainer = globalThis.gameViewAppPixiResponsive.GetBaseGameResponsiveContainer();
        const fixedContainer = globalThis.gameViewAppPixiResponsive.GetReelsGameResponsiveContainer();
        const panelContainer = globalThis.gameViewAppPixiResponsive.GetPanelContainer();

        const doublePlaceHolder = this.spineHit.children.find(ele => ele.name == "DoublePlaceHolder") as PIXI.Container;
        const jackpotPlaceHolder = this.spineHit.children.find(ele => ele.name == "JackpotPlaceHolder") as PIXI.Container;
        const multiplierPlaceHolder = this.spineHit.children.find(ele => ele.name == "MultiplierPlaceHolder") as PIXI.Container;

        const newPotCollection = (): PotCollectPosition[] => {

            const multiplierTargetPosition = multiplierPlaceHolder.parent.toGlobal(multiplierPlaceHolder.position);
            console.log("multiplierPlaceHolder", multiplierTargetPosition);

            const jackpotTargetPosition = jackpotPlaceHolder.parent.toGlobal(jackpotPlaceHolder.position);
            console.log("jackpotPlaceHolder", jackpotTargetPosition);

            const doubleTargetPosition = doublePlaceHolder.parent.toGlobal(doublePlaceHolder.position);
            console.log("doublePlaceHolder", doubleTargetPosition);

            const pos = [
                {
                    name: "SRAM",
                    position: {
                        x: multiplierTargetPosition.x,
                        y: multiplierTargetPosition.y,
                    }
                },
                {
                    name: "SRAJ",
                    position: {
                        x: jackpotTargetPosition.x,
                        y: jackpotTargetPosition.y,
                    }
                },
                {
                    name: "SRAD",
                    position: {
                        x: doubleTargetPosition.x,
                        y: doubleTargetPosition.y,
                    }
                },
            ]
            return pos;
        }

        let flipAnimation: IAnimation = null;
        console.log("UpdatePixiAppDistribution().anims", this.spineHit.spineData.animations);


        if (GetOrientation() == Orientation.Landscape) {

            // const scaleX = fixedContainer.calculatedWidth / this.puppetSize.landscape.Width;
            const scale = Scale.H(1080) / this.puppetSize.landscape.Height;
            // const scale = Math.min(scaleX, scaleY)

            baseGameContainer.percentY = 0.13;
            baseGameContainer.percentX = 0.15;
            baseGameContainer.percentWidth = 0.70;
            baseGameContainer.percentHeight = 0.87;

            flipAnimation = this.spineHit.spineData.animations.find(a => a.name == `flip${GetOrientation()}`);
            this.spineHit.state.setAnimation(this.spineHit.spineData.animations.length + 1, flipAnimation.name, false);
            this.spineHit.update(0);

            this.spineHit.scale.set(scale);
            this.spineHit.position.x = - (this.puppetSize.landscape.Width / 2) * scale//- this.puppetSize.landscape.Width / 2//fixedContainer.fixedWidth / 2;
            this.spineHit.position.y = (fixedContainer.fixedHeight / 2);

            // this.potCollectPosition = newPotCollection();

            const newTargets = newPotCollection();
            console.log("newPotCollectionPosLandscape", newTargets);
            this.familyFillingPotFeature.UpdateTargetsGlobal(newTargets);


            //console.log("currentPotCollectionPos", this.familyFillingPotFeature.GetDataPositionPot());

            return;
        }

        baseGameContainer.percentY = 0.55;
        baseGameContainer.percentX = 0;
        baseGameContainer.percentWidth = 1;
        baseGameContainer.percentHeight = 0.25;




        const scaleX = 1920 / this.puppetSize.landscape.Width; 
        const scaleY = 1080 / this.puppetSize.landscape.Height;
        const scale = Math.min(scaleX, scaleY)

        this.spineHit.scale.set(scale);
        
        flipAnimation = this.spineHit.spineData.animations.find(a => a.name == `flip${GetOrientation()}`);
        this.spineHit.state.setAnimation(this.spineHit.spineData.animations.length + 1, flipAnimation.name, false);
        this.spineHit.update(0);

        // this.spineHit.scale.set(scale * 1.5);
        this.spineHit.position.x = (fixedContainer.fixedWidth / 2);
        this.spineHit.position.y = - (this.puppetSize.portrait.Height / 4);

        // console.log("newPotCollectionPosPortrait", newPotCollectionPos);

        
        const newTargets = newPotCollection();
        console.log("newPotCollectionPosLandscape", newTargets);
        this.familyFillingPotFeature.UpdateTargetsGlobal(newTargets);

    }

    private SetToDefault() {

        this.spineHit.scale.set(1);
        this.spineHit.position.set(0, 0);
        this.potCollectPosition = [];

        const baseGameContainer = globalThis.gameViewAppPixiResponsive.GetBaseGameResponsiveContainer();

        baseGameContainer.percentY = 0;
        baseGameContainer.percentX = 0;
        baseGameContainer.percentWidth = 1;
        baseGameContainer.percentHeight = 1;

        
        
        
    }

    public override FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay: string) {
        //this.familyFillingPotFeature?.FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay);        
    }

    public override StartPoppetRA() {
        //this.randomAnimationFeature.StartRAPoppet();
    }

    public override StopPoppetRA() {
        //this.randomAnimationFeature.StopsRAPoppet();
    }

    public OnResize() {
        this.UpdatePixiAppDistribution();
        this.familyFillingPotFeature.OnResize();
    }

}
